import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { AuthBoxContainer } from './AuthList.css';

const SafetyAuthBox = ({ auths, selectAuth, setSelectAuth }) => {
  const handleClick = (auth) => {
    setSelectAuth(auth);
  };

  return (
    <AuthBoxContainer>
      <div className="title">안전관리자</div>
      <div className="content-box">
        {auths.map((auth) => {
          if (auth.memo.length > 18) {
            return (
              <OverlayTrigger key={'bottom'} placement={'bottom'} overlay={<Tooltip id={`tooltip`}>{auth.memo}</Tooltip>}>
                <div
                  className={classNames('content', selectAuth && selectAuth.authIdx === auth.authIdx && 'on')}
                  onClick={() => {
                    handleClick(auth);
                  }}
                >
                  ● {auth.authNm} - {auth.memo}
                </div>
              </OverlayTrigger>
            );
          }

          return (
            <div
              className={classNames('content', selectAuth && selectAuth.authIdx === auth.authIdx && 'on')}
              onClick={() => {
                handleClick(auth);
              }}
            >
              ● {auth.authNm} - {auth.memo.length === 0 ? <span style={{color: 'gray'}}>메모 없음</span> : auth.memo}
            </div>
          );
        })}
      </div>
    </AuthBoxContainer>
  );
};

export default SafetyAuthBox;
